import { CustomModalLayout, Text } from '@wix/design-system';
import { UrlUtils } from '@wix/package-picker-shared';
import React from 'react';
import { SwitchProductModule } from '../../switch-product.module';
const getErrorProps = errorType => {
  if (errorType === 'dataRetrievalFailed') {
    return {
      title: 'Advanced_Plans_change_plan_modal_data_retrieval_error_title',
      body: ['Advanced_Plans_change_plan_modal_data_retrieval_error_body'],
      primaryButton: {
        textKey: 'change_plan.change_plan_modal.ok',
        action: 'closeModal'
      },
      secondaryButton: {
        textKey: 'Advanced.Plans_change.plan_modal_error_support_contact',
        action: 'contactSupport'
      }
    };
  }
  if (errorType === 'changeProductFailed') {
    return {
      title: 'Advanced.Plans_change.plan_modal_error.title',
      body: ['Advanced.Plans_change.plan_modal_error.body'],
      primaryButton: {
        textKey: 'Advanced.Plans_change.plan_modal_error_support_contact',
        action: 'contactSupport'
      },
      secondaryButton: {
        textKey: 'change_plan.change_plan_modal.ok',
        action: 'closeModal'
      }
    };
  }
  if (errorType === 'invalidEuVatNumberException') {
    return {
      title: 'Advanced.Plans_change.plan_modal_error.title',
      body: ['Advanced_Plans_change_plan_modal_eu_vat_error_body_par1', '\n\n', 'Advanced_Plans_change_plan_modal_eu_vat_error_body_par2'],
      primaryButton: {
        textKey: 'Advanced.Plans_change.plan_modal_error_support_contact',
        action: 'contactSupport'
      },
      secondaryButton: {
        textKey: 'change_plan.change_plan_modal.ok',
        action: 'closeModal'
      }
    };
  }
  return;
};
export const DowngradeErrorModal = _ref => {
  let {
    errorType,
    error,
    callbacks
  } = _ref;
  const {
    t
  } = SwitchProductModule.internals.useTranslations();
  const errorProps = getErrorProps(errorType);
  React.useEffect(() => {
    // 17:2259
    callbacks == null || callbacks.onShow == null || callbacks.onShow({
      errorType,
      error
    });
  }, [callbacks, errorType, error]);
  if (!errorProps) {
    SwitchProductModule.internals.modalsController.DowngradeErrorModal.hide();
    return null;
  }
  const closeModal = () => {
    // TODO: BI event 17:2261
    callbacks == null || callbacks.onClose == null || callbacks.onClose({
      errorType,
      error
    });
    SwitchProductModule.internals.modalsController.DowngradeErrorModal.hide();
  };
  const contactSupport = () => {
    // TODO: BI event 17:2260
    const url = UrlUtils.buildUrl({
      url: 'https://www.wix.com/about/contact-us',
      params: {
        referralAdditionalInfo: 'advPlans'
      }
    });
    callbacks == null || callbacks.onClick == null || callbacks.onClick({
      errorType,
      error,
      action: 'contactSupport',
      data: {
        url
      }
    });
    window.location.assign(url);
    SwitchProductModule.internals.modalsController.DowngradeErrorModal.hide();
  };
  const handleButtonClick = action => {
    if (action === 'closeModal') {
      closeModal();
    } else if (action === 'contactSupport') {
      contactSupport();
    }
  };
  return /*#__PURE__*/React.createElement(CustomModalLayout, {
    width: "604px",
    title: t(errorProps.title),
    dataHook: "changeProductErrorModal",
    onCloseButtonClick: closeModal,
    primaryButtonOnClick: () => handleButtonClick(errorProps.primaryButton.action),
    primaryButtonText: t(errorProps.primaryButton.textKey),
    secondaryButtonOnClick: () => handleButtonClick(errorProps.secondaryButton.action),
    secondaryButtonText: t(errorProps.secondaryButton.textKey)
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: "changeProductErrorBody"
  }, errorProps.body.map(key => t(key))));
};
//# sourceMappingURL=DowngradeErrorModal.js.map